import { request } from '@/utils/request'
export default {
    pageData: (params, loading) => {
        return request('/api/user/queryPage', params, loading)
    },
    updateUser: (params, loading) => {
        return request('/api/user/sync', params, loading)
    },
}


// WEBPACK FOOTER //
// ./src/api/systemUser.js